module.exports = __webpack_public_path__ + "img/icn-prapluie.06378262.svg";